export const GET_PATIENTS_REQUEST = "GET_PATIENTS_REQUEST";
export const GET_PATIENTS_SUCCESS = "GET_PATIENTS_SUCCESS";
export const GET_PATIENTS_FAIL = "GET_PATIENTS_FAIL";
export const GET_PATIENTS_RESET = "GET_PATIENTS_RESET";

export const GET_ALL_PATIENTS_REQUEST = "GET_ALL_PATIENTS_REQUEST";
export const GET_ALL_PATIENTS_SUCCESS = "GET_ALL_PATIENTS_SUCCESS";
export const GET_ALL_PATIENTS_FAIL = "GET_ALL_PATIENTS_FAIL";
export const GET_ALL_PATIENTS_RESET = "GET_ALL_PATIENTS_RESET";

export const CREATE_PATIENT_REQUEST = "CREATE_PATIENT_REQUEST";
export const CREATE_PATIENT_SUCCESS = "CREATE_PATIENT_SUCCESS";
export const CREATE_PATIENT_FAIL = "CREATE_PATIENT_FAIL";
export const CREATE_PATIENT_RESET = "CREATE_PATIENT_RESET";

export const DELETE_PATIENT_REQUEST = "DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS = "DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAIL = "DELETE_PATIENT_FAIL";
export const DELETE_PATIENT_RESET = "DELETE_PATIENT_RESET";

export const GET_PATIENT_DETAILS_REQUEST = "GET_PATIENT_DETAILS_REQUEST";
export const GET_PATIENT_DETAILS_SUCCESS = "GET_PATIENT_DETAILS_SUCCESS";
export const GET_PATIENT_DETAILS_FAIL = "GET_PATIENT_DETAILS_FAIL";
export const GET_PATIENT_DETAILS_RESET = "GET_PATIENT_DETAILS_RESET";

export const UPDATE_PATIENT_REQUEST = "UPDATE_PATIENT_REQUEST";
export const UPDATE_PATIENT_SUCCESS = "UPDATE_PATIENT_SUCCESS";
export const UPDATE_PATIENT_FAIL = "UPDATE_PATIENT_FAIL";
export const UPDATE_PATIENT_RESET = "UPDATE_PATIENT_RESET";

export const GET_PATIENT_ACTIVITY_LOG_REQUEST =
  "GET_PATIENT_ACTIVITY_LOG_REQUEST";
export const GET_PATIENT_ACTIVITY_LOG_SUCCESS =
  "GET_PATIENT_ACTIVITY_LOG_SUCCESS";
export const GET_PATIENT_ACTIVITY_LOG_FAIL = "GET_PATIENT_ACTIVITY_LOG_FAIL";
export const GET_PATIENT_ACTIVITY_LOG_RESET = "GET_PATIENT_ACTIVITY_LOG_RESET";

export const GET_PATIENT_TREATMENT_PLANS_REQUEST =
  "GET_PATIENT_TREATMENT_PLANS_REQUEST";
export const GET_PATIENT_TREATMENT_PLANS_SUCCESS =
  "GET_PATIENT_TREATMENT_PLANS_SUCCESS";
export const GET_PATIENT_TREATMENT_PLANS_FAIL =
  "GET_PATIENT_TREATMENT_PLANS_FAIL";
export const GET_PATIENT_TREATMENT_PLANS_RESET =
  "GET_PATIENT_TREATMENT_PLANS_RESET";

export const PATIENT_ADDRESS_STATES_REQUEST = "PATIENT_ADDRESS_STATES_REQUEST";
export const PATIENT_ADDRESS_STATES_SUCCESS = "PATIENT_ADDRESS_STATES_SUCCESS";
export const PATIENT_ADDRESS_STATES_FAIL = "PATIENT_ADDRESS_STATES_FAIL";
export const PATIENT_ADDRESS_STATES_RESET = "PATIENT_ADDRESS_STATES_RESET";

export const PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST =
  "PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST";
export const PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS =
  "PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS";
export const PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL =
  "PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL";
export const PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_RESET =
  "PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_RESET";

export const PATIENT_VERIFY_PORTAL_PIN_REQUEST =
  "PATIENT_VERIFY_PORTAL_PIN_REQUEST";
export const PATIENT_VERIFY_PORTAL_PIN_SUCCESS =
  "PATIENT_VERIFY_PORTAL_PIN_SUCCESS";
export const PATIENT_VERIFY_PORTAL_PIN_FAIL = "PATIENT_VERIFY_PORTAL_PIN_FAIL";
export const PATIENT_VERIFY_PORTAL_PIN_RESET =
  "PATIENT_VERIFY_PORTAL_PIN_RESET";

export const PATIENT_REFRESH_PORTAL_TOKEN_REQUEST =
  "PATIENT_REFRESH_PORTAL_TOKEN_REQUEST";
export const PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS =
  "PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS";
export const PATIENT_REFRESH_PORTAL_TOKEN_FAIL =
  "PATIENT_REFRESH_PORTAL_TOKEN_FAIL";
export const PATIENT_REFRESH_PORTAL_TOKEN_RESET =
  "PATIENT_REFRESH_PORTAL_TOKEN_RESET";

export const PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST =
  "PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST";
export const PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS =
  "PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS";
export const PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL =
  "PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL";
export const PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_RESET =
  "PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_RESET";

export const PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST =
  "PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST";
export const PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS =
  "PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS";
export const PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL =
  "PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL";
export const PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_RESET =
  "PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_RESET";

export const PATIENT_PORTAL_APPROVE_PLAN_REQUEST =
  "PATIENT_PORTAL_APPROVE_PLAN_REQUEST";
export const PATIENT_PORTAL_APPROVE_PLAN_SUCCESS =
  "PATIENT_PORTAL_APPROVE_PLAN_SUCCESS";
export const PATIENT_PORTAL_APPROVE_PLAN_FAIL =
  "PATIENT_PORTAL_APPROVE_PLAN_FAIL";
export const PATIENT_PORTAL_APPROVE_PLAN_RESET =
  "PATIENT_PORTAL_APPROVE_PLAN_RESET";

export const PATIENT_PORTAL_CANCEL_PLAN_REQUEST =
  "PATIENT_PORTAL_CANCEL_PLAN_REQUEST";
export const PATIENT_PORTAL_CANCEL_PLAN_SUCCESS =
  "PATIENT_PORTAL_CANCEL_PLAN_SUCCESS";
export const PATIENT_PORTAL_CANCEL_PLAN_FAIL =
  "PATIENT_PORTAL_CANCEL_PLAN_FAIL";
export const PATIENT_PORTAL_CANCEL_PLAN_RESET =
  "PATIENT_PORTAL_CANCEL_PLAN_RESET";
